import { useGetRoutesWithPositions } from '@/generated/client/routes/routes';

import { selectRoutesResult } from '@/components/routes/api/routesMapper';

export const ROUTES_QUERY_STALE_TIME_MS = 30_000;

export type RoutesDateRange = {
  from: Date;
  to: Date;
};

type UseRoutesQueryParams = {
  targetId: number | undefined;
  dates: RoutesDateRange | undefined;
};

export type RoutesQuery = ReturnType<typeof useRoutesQuery>;

function toTimeMicros(date: Date) {
  return date.getTime() * 1000;
}

export function useRoutesQuery({ targetId, dates }: UseRoutesQueryParams) {
  const isEnabled = targetId !== undefined && dates !== undefined;

  return useGetRoutesWithPositions(
    // Orval requires a number, but enabled prevents this sentinel from reaching the API.
    targetId ?? 0,
    {
      fromTime: dates ? toTimeMicros(dates.from) : 0,
      toTime: dates ? toTimeMicros(dates.to) : 0,
    },
    {
      query: {
        enabled: isEnabled,
        retry: false,
        staleTime: ROUTES_QUERY_STALE_TIME_MS,
        select: selectRoutesResult,
      },
    }
  );
}
